import type { RoomLayout, Questionnaire } from '../../data-transformer/index.ts';

export const ROOM_TEMPLATES: Record<string, RoomLayout> = {
  empty: {
    id: "room-empty",
    name: "Empty 5x5 Room",
    width: 5.0,
    length: 5.0,
    height: 3.0,
    items: []
  },
  office: {
    id: "room-office",
    name: "Compact Home Office",
    width: 4.5,
    length: 5.0,
    height: 2.8,
    items: [
      {
        itemId: "desk-1",
        label: "Executive Desk",
        description: "Large wooden executive desk for workspace area",
        type: "desk",
        position: { x: 2.25, y: 1.2, z: 0 },
        size: { width: 1.5, length: 0.75, height: 0.75 },
        angle: 0,
        colors: [{ r: 139, g: 69, b: 19 }], // brown
        materials: ["wood"]
      },
      {
        itemId: "chair-1",
        label: "Ergonomic Chair",
        description: "Mesh high-back ergonomic office chair",
        type: "chair",
        position: { x: 2.25, y: 2.0, z: 0 },
        size: { width: 0.65, length: 0.65, height: 1.0 },
        angle: 180,
        colors: [{ r: 0, g: 0, b: 0 }], // black
        materials: ["plastic", "fabric"]
      },
      {
        itemId: "cabinet-1",
        label: "Filing Cabinet",
        description: "Metal filing cabinet for storage",
        type: "cabinet",
        position: { x: 0.5, y: 4.0, z: 0 },
        size: { width: 0.9, length: 0.45, height: 1.2 },
        angle: 90,
        colors: [{ r: 128, g: 128, b: 128 }], // grey
        materials: ["metal"]
      },
      {
        itemId: "lounge-1",
        label: "Reading Chair",
        description: "Comfortable leather lounge chair",
        type: "chair",
        position: { x: 3.8, y: 4.2, z: 0 },
        size: { width: 0.8, length: 0.8, height: 0.85 },
        angle: 315,
        colors: [{ r: 210, g: 105, b: 30 }], // chocolate brown
        materials: ["leather", "wood"]
      }
    ]
  },
  living: {
    id: "room-living",
    name: "Spacious Living Room",
    width: 6.0,
    length: 6.0,
    height: 3.0,
    items: [
      {
        itemId: "sofa-1",
        label: "Sectional Sofa",
        description: "Comfortable grey fabric sectional sofa",
        type: "sofa",
        position: { x: 3.0, y: 1.5, z: 0 },
        size: { width: 2.4, length: 0.95, height: 0.8 },
        angle: 0,
        colors: [{ r: 100, g: 100, b: 100 }], // grey
        materials: ["fabric"]
      },
      {
        itemId: "tv-unit-1",
        label: "Media Console",
        description: "Low-profile TV stand unit",
        type: "cabinet",
        position: { x: 3.0, y: 5.2, z: 0 },
        size: { width: 1.8, length: 0.4, height: 0.5 },
        angle: 180,
        colors: [{ r: 0, g: 0, b: 0 }], // black
        materials: ["wood", "metal"]
      },
      {
        itemId: "coffee-table",
        label: "Wood Coffee Table",
        description: "Solid oak coffee table",
        type: "table",
        position: { x: 3.0, y: 2.8, z: 0 },
        size: { width: 1.1, length: 0.7, height: 0.4 },
        angle: 0,
        colors: [{ r: 160, g: 82, b: 45 }], // sienna
        materials: ["wood"]
      },
      {
        itemId: "plant-1",
        label: "Fiddle Leaf Fig",
        description: "Indoor potted plant for decoration",
        type: "decoration",
        position: { x: 0.5, y: 5.2, z: 0 },
        size: { width: 0.5, length: 0.5, height: 1.5 },
        angle: 0,
        colors: [{ r: 34, g: 139, b: 34 }], // forest green
        materials: ["organic"]
      }
    ]
  }
};

export const DEFAULT_QUESTIONNAIRE: Questionnaire = {
  numberOfAdults: 2,
  numberOfChildren: 0,
  numberOfGuests: 2,
  workplace: true,
  playground: false
};
